import { useState } from 'react';
import { Modal } from '@/components/dialogs/Modal';
import { tenantStore } from './tenantStore';

// Legacy "switch tenant" box shown on the login page for host/localhost: lets
// you type a tenant name/id, stored and sent as the __tenant header.
export function TenantSwitcher() {
  const [tenant, setTenant] = useState(tenantStore.effective());
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(tenant);

  if (!tenantStore.isSwitchable()) return null;

  function openModal() {
    setDraft(tenantStore.get());
    setOpen(true);
  }

  function save() {
    tenantStore.set(draft);
    setTenant(tenantStore.effective());
    setOpen(false);
  }

  return (
    <div className="card custom-card mt-3">
      <div className="card-body py-3">
        <div className="row align-items-center">
          <div className="col">
            <span style={{ fontSize: '.8em' }} className="text-uppercase text-muted">
              Tenant
            </span>
            <br />
            <h6 className="m-0 d-inline-block">
              {tenant ? <strong>{tenant}</strong> : <span className="text-muted">Not selected (host)</span>}
            </h6>
          </div>
          <div className="col-auto">
            <button type="button" className="btn btn-sm btn-outline-primary" onClick={openModal}>
              Switch
            </button>
          </div>
        </div>
      </div>

      <Modal
        show={open}
        title="Switch tenant"
        onClose={() => setOpen(false)}
        footer={
          <>
            <button type="button" className="btn btn-light" onClick={() => setOpen(false)}>
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={save}>
              Save
            </button>
          </>
        }
      >
        <label htmlFor="tenant-name" className="form-label">
          Name
        </label>
        <input
          id="tenant-name"
          className="form-control"
          placeholder="Leave empty for host"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter') save();
          }}
        />
        <div className="form-text">Used as the tenant for sign-in on this host.</div>
      </Modal>
    </div>
  );
}
